// DO NOT EDIT MANUALLY
// This file was automatically generated by `scripts/MapboxStyles/process.ts`

import { MapboxStyleLayer } from '../types'

export const mapboxStyleGroupLayers_atlas_bikelanes_plus_signs: MapboxStyleLayer[] = [
  {
    minzoom: 10,
    layout: {
      'text-size': ['interpolate', ['linear'], ['zoom'], 12, 7, 22, 14],
      'icon-image': [
        'case',
        ['match', ['get', 'traffic_sign'], ['DE:241-31', 'DE:241'], true, false],
        'Zeichen_241-31_1992',
        [
          'match',
          ['get', 'traffic_sign'],
          ['DE:239,1022-10', 'de:239,1022-10', 'DE:239;237;258'],
          true,
          false,
        ],
        'Zeichen_239_1992',
        ['match', ['get', 'traffic_sign'], ['DE:237', 'DE:239;237;258'], true, false],
        'Zeichen_237_1992',
        [
          'match',
          ['get', 'traffic_sign'],
          ['DE:240;258', 'DE:240,1000-31', 'DE:240', 'DE:240;1000-31'],
          true,
          false,
        ],
        'Zeichen_240_1992',
        ['match', ['get', 'traffic_sign'], ['241-30'], true, false],
        'Zeichen_241-30_1992',
        ['match', ['get', 'traffic_sign'], ['DE:229', '242'], true, false],
        'Zeichen_242.1_-_Beginn_einer_FuÃgaÌngerzone,_StVO_2009',
        ['match', ['get', 'traffic_sign'], ['DE:244.1'], true, false],
        'Zeichen_244.1_-_Beginn_einer_FahrradstraÃe,_StVO_2013',
        ['match', ['get', 'traffic_sign'], ['DE:325;357,1026-32'], true, false],
        'Zeichen_3690',
        ['match', ['get', 'traffic_sign'], ['245'], true, false],
        'Zeichen_5274',
        'dot-9',
      ],
      'text-font': ['Open Sans Regular', 'Arial Unicode MS Regular'],
      'text-offset': [
        'interpolate',
        ['linear'],
        ['zoom'],
        12,
        ['literal', [0, 1.3]],
        22,
        ['literal', [0, 4]],
      ],
      'icon-size': ['interpolate', ['linear'], ['zoom'], 10, 0.3, 13, 0.6, 22, 1.5],
      'text-anchor': 'top',
      'text-field': ['to-string', ['get', 'traffic_sign']],
      'icon-padding': 50,
      'icon-ignore-placement': true,
    },
    filter: [
      'match',
      ['get', 'traffic_sign'],
      [
        'DE:239,1022-10',
        'DE:239;237;258',
        'DE:240',
        'DE:240;258',
        'DE:240,1000-31',
        'DE:241',
        'DE:241-31',
        'DE:237',
        'DE:240;1000-31',
        'DE:244.1',
        'DE:245',
        'DE:325;357,1026-32',
      ],
      true,
      false,
    ],
    type: 'symbol',
    id: 'trafficsigns',
    paint: {
      'text-color': '#575757',
      'text-opacity': ['interpolate', ['linear'], ['zoom'], 13.5, 0, 13.6, 1],
    },
  },
]
